import { useContext } from 'react';

import { DigitalCoreContext, AuthenticationContext } from './provider';

const useDC = (): AuthenticationContext => useContext(DigitalCoreContext);

export default useDC;
